<template>
  <b-modal v-model="showModal" hide-footer centered>
    <validation-observer ref="createForm" >
      <b-form class="form mt-2" @submit.prevent="createForm">
        <b-form-group label-for="subject" class="w-100" label="Subject">
          <validation-provider
            #default="{ errors }"
            name="subject"
            rules="required"
          >
            <b-form-input
              v-model="subject"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group label-for="content" label="Content">
          <validation-provider
            #default="{ errors }"
            name="content"
            rules="required"
          >
            <b-form-textarea
              id="content"
              v-model="content"
              name="content"
              :state="errors.length > 0 ? false : null"
              rows="4"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <div class="d-flex align-items-center justify-content-end">
          <b-button variant="primary" type="submit" >
            submit
          </b-button>
        </div>
      </b-form>
    </validation-observer>
    <loader :loading="loading" />
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";

import {
  BModal,
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BFormRadioGroup,
} from "bootstrap-vue";
import { required } from "@validations";
import Loader from "@/@core/components/loader/Loader.vue";

export default {
  components: {
    BModal,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BFormRadioGroup,
    ValidationProvider,
    ValidationObserver,
    Loader,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showModal: {
      get() {
        return this.visible;
      },
      set(newVal) {
        this.$emit("input", newVal);
      },
    },
  },
  data() {
    return {
      subject: "",
      content: "",
      loading: false,
      // validation rules
      required,
    };
  },

  methods: {
    createForm() {
      this.$refs.createForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            const { data } = await this.$http.post("panel/protests", {
              subject: this.subject,
              content: this.content,
              competition_id: this.$route.params.id,
            });
            this.subject = "";
            this.content = "";
            this.showModal = false;
          } catch (err) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style></style>
